import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_FLESH_EATER_COURTS: {
    name: 'Battletome: Flesh-Eater Courts',
    type: 'battletome',
  },
} satisfies TRuleSources

export default rule_sources
